import { FirebaseError } from "firebase/app";

export const FIREBASE_TRANSLATE_ERRORS: Record<FirebaseError['code'], string> = {
    'auth/invalid-email': 'Invalid email address.',
    'auth/user-disabled': 'User has been disabled.',
    'auth/user-not-found': 'User not found.',
    'auth/wrong-password': 'Wrong password.',
    'auth/operation-not-allowed': 'Operation not allowed.',
    'auth/weak-password': 'Weak password.',
    'auth/email-already-in-use': 'Email already in use.',
    'auth/too-many-requests': 'Too many requests. Please try again later.',
    'auth/expired-action-code': 'Action code has expired.',
    'auth/invalid-action-code': 'Invalid action code.',
    'auth/invalid-verification-code': 'Invalid verification code.',
    'auth/invalid-verification-id': 'Invalid verification ID.',
    'auth/missing-verification-code': 'Missing verification code.',
    'auth/missing-verification-id': 'Missing verification ID.',
    'auth/invalid-credential': 'Your email / password combination is incorrect.',
    'auth/invalid-continue-uri': 'Invalid continue URI.',
    'auth/unauthorized-continue-uri': 'Unauthorized continue URI.',
    'auth/invalid-dynamic-link-domain': 'Invalid dynamic link domain.',
    'auth/argument-error': 'Argument error.',
    'auth/invalid-persistence': 'Invalid persistence.',
    'auth/unsupported-persistence': 'Unsupported persistence.',
    'auth/timeout': 'Request timed out.',
    'auth/invalid-api-key': 'Invalid API key.',
    'auth/network-request-failed': 'Network request failed.',
    'unknown': 'Unknown error occurred.',
}
